import React from 'react';
import moment from 'moment';
import {capitalize } from 'lodash';

const DialysisPrint = ({ data }) => {
    const {
        patient = {},
        provider = {},
        machine_room_no,
        duration_hrs,
        is_permanent,
        is_transient,
        date,
        time_on,
        time_off,
        medication_orders,
        pre_dialysis_evaluation,
        dry_weight,
        infusion_rinse,
        infusion_drink,
        infusion_blood,
        est_weight_loss_ml,
        total_weight_loss_ml,
        target_weight_loss_kg,
        heparin_bolus,
        hourly_rate,
        blood_flow_rate,
        dialyzer,
        dialysate_flow,
        access,
        program_na_modelling,
        bruit,
        prev_weight,
        prev_bp,
        prev_pulse,
        prev_temp,
        pre_weight,
        pre_bp,
        pre_pulse,
        pre_temp,
        post_weight,
        post_bp,
        post_pulse,
        post_temp,
        comments,
        address = {},
        dialysisData = []
    } = data;

    const calculateAge = (dob) => {
        if (!dob) return null;
        const birth = moment(dob);
        const now = moment();
        const years = now.diff(birth, 'years');
        const months = now.diff(birth.clone().add(years, 'years'), 'months');
        return { years, months };
    };

    const age = calculateAge(patient.date_of_birth);

    return (
<>
        <div style={{ fontFamily: 'Arial', padding: 20, fontSize: 12 }}>
        <style>
        {`
            table td, table th {
                text-align: left;
                vertical-align: top;
            }
        `}
    </style>
        {/* Header */}
        <div style={{ textAlign: 'left', marginBottom: -10 }}>
            <h2 style={{ margin: 0 }}>{provider.service_provider_name}</h2>
        </div>
        <div style={{ textAlign: 'right', marginBottom: 20 }}>
            <p style={{ margin: 0 }}>{address.address.address_line_1}</p>
            <p style={{ margin: 0 }}>{address.address.city}{address.address.parish}{address.address.pincode}</p>
            <p style={{ margin: 0 }}>Contact Number: {provider.contact_number}</p>
            <p style={{ margin: 0 }}>Registration Number: {provider.license_number}</p>
        </div>

        {/* Patient Info */}
        <h3 style={{fontSize:'14px'}}>Patient Info</h3>
        <table border="1" cellPadding="5" cellSpacing="0" style={{ width: '100%', marginBottom: 20, tableLayout: 'fixed'}}>
                <tbody>                 
                    <tr>
                        <td><strong>Name: </strong>{patient.full_name}</td>
                        <td><strong>Age: </strong>{age && age.years} years {age && age.months} months</td>                  
                        <td><strong>Gender: </strong>{capitalize(patient.gender)}</td>
                    </tr>
                </tbody>
            </table>
            <table border="1" cellPadding="5" cellSpacing="0" style={{ width: '100%', marginBottom: 20, tableLayout: 'fixed'}}>
                <tbody>                 
                    <tr>
                        <td><strong>Machine/Room No:</strong></td><td>{machine_room_no}</td>                      
                        <td><strong>Duration (hrs):</strong></td><td>{duration_hrs}</td>
                    </tr>
                    <tr>
                        <td><strong>Permanent:</strong></td><td>{is_permanent ? 'Yes' : 'No'}</td>
                        <td><strong>Transient:</strong></td><td>{is_transient ? 'Yes' : 'No'}</td>
                    </tr>
                    <tr>
                        <td><strong>Date:</strong></td><td>{moment(date).format('YYYY-MM-DD')}</td>
                        <td><strong>Time On:</strong></td><td> {time_on}</td>
                    </tr>
                    <tr>
                        <td><strong>Time Off:</strong></td><td>{time_off}</td>
                        <td><strong>Medication Orders:</strong></td><td> {medication_orders}</td>
                    </tr>                 
                </tbody>
            </table>

            <h3>Pre-Dialysis Information/Instructions</h3>    
            <table border="1" cellPadding="5" cellSpacing="0" style={{ width: '100%', marginBottom: 20, tableLayout: 'fixed' }}>
                <tbody>                 
                    <tr>
                        <td><strong>Pre-Dialysis Evalution:</strong></td><td>{pre_dialysis_evaluation}</td>                      
                        <td><strong>Dry Weight:</strong></td><td>{dry_weight}</td>
                    </tr>
                    <tr>
                        <td><strong>Infusion Rinse:</strong></td><td>{infusion_rinse}</td>
                        <td><strong>Infusion Drink:</strong></td><td>{infusion_drink}</td>
                    </tr>
                    <tr>
                        <td><strong>Infusion Blood:</strong></td><td> {infusion_blood}</td>
                        <td><strong>Est. weight loss (ml):</strong></td><td> {est_weight_loss_ml}</td>
                    </tr>
                    <tr>
                        <td><strong>Total weight loss (ml):</strong></td><td>{total_weight_loss_ml}</td>
                        <td><strong>Target weight loss(kg):</strong></td><td> {target_weight_loss_kg}</td>
                    </tr>
                    <tr>
                        <td><strong>Heparin - Bolus:</strong></td><td>{heparin_bolus}</td>
                        <td><strong>Dialyzer:</strong></td><td>{dialyzer}</td>
                    </tr>
                    <tr>
                        <td><strong>Hourly-rate:</strong></td><td>{hourly_rate}</td>
                        <td><strong>Blood Flow Rate:</strong></td><td> {blood_flow_rate}</td>
                    </tr>     
                    <tr>
                        <td><strong>Access:</strong></td><td>{access}</td>
                        <td><strong>Program Na+ Modelling:</strong></td><td> {program_na_modelling}</td>
                    </tr>  
                    <tr>
                        <td><strong>Bruit:</strong></td><td>{bruit}</td>                       
                    </tr>                 
                </tbody>
            </table>

            <table border="1" cellPadding="5" cellSpacing="0" style={{ width: '100%', marginBottom: 20, tableLayout: 'fixed' }}>
                <thead>
                    <tr>
                        <th><strong>Parameters</strong></th>
                        <th><strong>Previous Discharge</strong></th>
                        <th><strong>Pre Dialysis</strong></th>
                        <th><strong>Post Dialysis</strong></th>
                    </tr>
                </thead>
                <tbody>
                        <tr>
                            <td><strong>Weight (kg)</strong></td>
                            <td>{prev_weight}</td>
                            <td>{pre_weight}</td>
                            <td>{post_weight}</td>
                        </tr>
                        <tr>
                            <td><strong>Blood Pressure(mm/Hg)</strong></td>
                            <td>{prev_bp}</td>
                            <td>{pre_bp}</td>
                            <td>{pre_bp}</td>
                        </tr>
                        <tr>
                            <td><strong>Pulse</strong></td>
                            <td>{prev_pulse}</td>
                            <td>{pre_pulse}</td>
                            <td>{post_pulse}</td>
                        </tr>
                        <tr>
                            <td><strong>Temperature(C)</strong></td>
                            <td>{prev_temp}</td>
                            <td>{pre_temp}</td>
                            <td>{post_temp}</td>
                        </tr>
                </tbody>
            </table>

            <table border="1" cellPadding="5" cellSpacing="0" style={{ width: '100%', marginBottom: 20 }}>
                <tbody>                 
                    <tr>
                        <td><strong>Comments:</strong></td><td>{comments}</td>
                    </tr>                       
                </tbody>
            </table>

            <div style={{ pageBreakBefore: 'always' }}>
                <h3>Dialysis Data Records</h3>
                <table border="1" cellPadding="5" cellSpacing="0" style={{ width: '100%', marginBottom: 20 }}>
                    <thead>
                        <tr>
                            <th>Time</th>
                            <th>Pulse</th>
                            <th>BP</th>
                            <th>Blood Flow</th>
                            <th>Art. Pressure</th>
                            <th>Venous Pressure</th>
                            <th>Temp</th>
                            <th>Dialysate Flow</th>
                            <th>Conductivity</th>
                            <th>Fluid Loss</th>
                            <th>Heparin</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dialysisData.map((item, i) => (
                            <tr key={i}>
                                <td>{item.recorded_time ? moment(item.recorded_time).format('YYYY-MM-DD HH:mm') : '-'}</td>
                                <td>{item.pulse}</td>
                                <td>{item.bp}</td>
                                <td>{item.blood_flow}</td>
                                <td>{item.art_press}</td>
                                <td>{item.venous_press}</td>
                                <td>{item.temperature}</td>
                                <td>{item.dialysate_flow}</td>
                                <td>{item.conductivity}</td>
                                <td>{item.fluid_loss}</td>
                                <td>{item.heparin}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <p>Printed On: {moment().format('YYYY-MM-DD HH:mm:ss')}</p>
        </div>

        </>
    );
};

export default DialysisPrint;